import { ReactNode } from "react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AdminSidebar } from "../sidebar/AdminSidebar";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";

interface AdminLayoutProps {
  children: ReactNode;
  onSignOut: () => void;
}

export function AdminLayout({ children, onSignOut }: AdminLayoutProps) {
  // DEPLOYMENT TEST - Ensure this version loads
  console.log('🎯 ADMIN LAYOUT V3 LOADED - SIDEBAR SHOULD BE VISIBLE');
  
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="min-h-screen flex w-full bg-background">
        <AdminSidebar onSignOut={onSignOut} />
        
        <main className="flex-1 flex flex-col overflow-x-hidden">
          {/* Header */}
          <header className="sticky top-0 z-10 h-16 border-b bg-background flex items-center justify-between px-4 shrink-0">
            <div className="flex items-center gap-4">
              <SidebarTrigger />
              <h1 className="text-xl font-semibold">Land Contract Admin Portal</h1>
            </div>
            
            <Button variant="outline" onClick={onSignOut} className="flex items-center gap-2">
              <LogOut className="h-4 w-4" />
              Sign Out
            </Button>
          </header>
          
          {/* Main Content */}
          <div className="flex-1 p-6 overflow-y-auto">
            <div className="max-w-7xl mx-auto">
              {children}
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}